const ReelController = require('ReelController');
const BlockPrefabController = require('BlockPrefabController');
const BasePrizeController = require('BasePrizeController');
const AudioManager = require('AudioManager');
const AudioMap = require('AudioMap');
const PaylinesController = require('PaylinesController');
const CameraController = require('CameraController');
const WildProgressController = require('WildProgressController');
const SplitPlacer = require('SplitPlacer');
const ShipController = require('ShipController');
const SpecialWildsController = require('SpecialWildsController');
const WayController = require('WayController');

const GameMode = cc.Enum({
    MAIN: 'mainGame',
    FREE_SPIN: 'FreeSpin'
});

const State = cc.Enum({
    IDLE: 'stateIdle',
    START_SPIN: 'stateStartSpin', // when we start spinning all the reels sequentially (takes some time)
    SPIN: 'stateSpin', // when all reels started to spin
    STOPPING_STEP_BY_STEP: 'stateStoppingStepByStep', // stop one by one/ first finish, then second ....
    STOPPING_IMMEDIATELY: 'stateStoppingImmediately', // stop all at once (for fast/slamStop)
    STOPPED: 'stateStopped',
    COLLECT_WILDS: 'stateCollectWilds',
    PLACE_WILDS: 'stateplaceWilds',
    CLEAN: 'stateClean', // clean all winnings and go to idle
    SHOW_ALL_WIN_ANIMATION: 'stateShowAllWinAnim', // showing all wins together
    SHOW_FREESPINS_WIN: 'stateFreespinsWin' // showing freespinsWin
});

const DURATION_BETWEEN_WIN_HIGHLIGHTS = 1;

cc.Class({
    extends: cc.Component,

    properties: {
        cameraController: CameraController,
        paylinesController: PaylinesController,
        wildProgress: WildProgressController,
        winSymbolsContainer: cc.Node,
        freespinsPrizeController: BasePrizeController,
        totalPrizeController: BasePrizeController,
        winlinePrizeController: BasePrizeController,
        splitPlacer: SplitPlacer,
        overlay: cc.Node,
        reelPrefab: cc.Prefab,
        reelContainer: cc.Node,
        shipControl: ShipController,
        specialWildsController: SpecialWildsController,
        wayController: WayController

    },

    ctor() {
        this.isSlamStop = false;
        this.currentWinningCluster = [];
        this.currentWinningCircles = [];
        this.totalStoppedScatter = 0;
        this.gameMode = GameMode.MAIN;
    },

    initConfig(winLines, paytable) {
        this.winLines = winLines;
        this.paytable = paytable;
    },

    onLoad() {
        this.audioManager = cc.find('AudioManager').getComponent(AudioManager);
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);

        this.freespinsPrizeController.node.active = false;

        this.totalPrizeController.node.on('winAnimationSetSlamStop', () => {
            this.node.emit('winAnimationSetSlamStop');
        });

        this.freespinsPrizeController.node.on('freespinTotalPrizeEnd', () => {
            this.node.emit('freespinTotalPrizeEnd');
        });

        this.totalPrizeController.node.on('bigWinAnimationStart', (isBigWin) => {
            this.node.emit('bigWinAnimationStart', isBigWin);
        });

        cc.game.on('TotalPrize', () => {
            this.freespinsPrizeController.showPrize(12345678901234, 100);
            this.scheduleOnce(() => {
                this.freespinsPrizeController.onClick();
            }, 7);
        });

        cc.game.on('TotalPrizeSmall', () => {
            this.freespinsPrizeController.showPrize(325, 100);
            this.scheduleOnce(() => {
                this.freespinsPrizeController.onClick();
            }, 7);
        });

        cc.game.on('bigwin', () => {
            this._showOverlay();
            this.totalPrizeController.showPrize(24500, 1000).then(() => this._hideOverlay());
        });
        cc.game.on('megawin', () => {
            this._showOverlay();
            this.totalPrizeController.showPrize(43500, 1000).then(() => this._hideOverlay());
            // this.totalPrizeController.showPrize(43500, 1000);
        });
        cc.game.on('epicwin', () => {
            this._showOverlay();
            this.totalPrizeController.showPrize(9955500, 1000).then(() => this._hideOverlay());
        });
    },

    setInitialPanelData(data, betAmount, precookedReels, taxonomy) { // calls only for first time
        this.gameState = data.gameState;
        this.panelData = data.panelData;
        this.winnings = data.winnings;
        this.betAmount = betAmount;
        this.taxonomy = taxonomy;
        this.splits = data.splits;

        this.splitPlacer.init(this.splits);

        this.gameMode = GameMode.MAIN;
        this.state = State.IDLE
        this.precookedReels = precookedReels;
        this._createReels();

        this.panelData.forEach((reelData, index) => {
            this.reels[index].setPrecookedReel(precookedReels[index]);
            this.reels[index].setInitData(reelData, index);
        });

        this._calculateTransitionMetrics();
    },


    _calculateTransitionMetrics() {
        // set the panel height the max height of the reels and the width of total reels width sum
        this.node.width = this.panelData.length * this.reels[0].node.width + 300;

        this.reelContainer.setScale(1, 1);
        this.winSymbolsContainer.setScale(1, 1);

        this.reelContainer.getComponent(cc.Layout).updateLayout();
    },

    _createReels() {
        this.reelContainer.getComponent(cc.Layout).enabled = true;
        this.reelContainer.removeAllChildren();
        this.reels = this.reels || [];
        this.reels.length = 0;

        for (let reel = 0; reel < this.panelData.length; reel++) {
            const newReel = cc.instantiate(this.reelPrefab);

            newReel.name = `Reel${reel + 1}`;
            newReel.index = reel;
            newReel.parent = this.reelContainer;
            // newReel.on('wildPlaced', this._wildIsPlacing, this );
            const reelController = newReel.getComponent(ReelController);

            this.reels.push(reelController);
        }
        this.reelContainer.getComponent(cc.Layout).enabled = false;
    },

    _wildIsPlacing () {
        this.wildProgress.consume();
    },

    setPanelData(data, betAmount) { // each sessions data
        this.collectedSpecialWilds = data.collectedSpecialWilds;
        if (data.placedSpecialWilds && data.placedSpecialWilds.length) {
            this.panelData = data.panelData;
            if (this.collectedSpecialWilds) {
                this.collectedSpecialWilds.forEach(specialWilds => {
                    this.panelData[specialWilds.reel][specialWilds.row] = 'WI_SP';

                });
            }
        } else {
            this.panelData = data.newPanelData;
        }

        this.gameState = data.gameState;
        this.placedSpecialWilds = data.placedSpecialWilds;
        this.placedSpecialWildsPerReel = data.placedSpecialWildsPerReel;
        this.collectedSpecialWilds = data.collectedSpecialWilds;
        this.winnings = data.winnings;
        this.scatterWinnings = data.scatterWinnings;
        this.splits = data.splits;

        this.betAmount = betAmount;

        if (data.mainSpecialWildProgress) {
            this.mainSpecialWildProgress = data.mainSpecialWildProgress;
        }
        if (data.fsSpecialWildProgress) {
            this.fsSpecialWildProgress = data.fsSpecialWildProgress;
        }

        this._calculateWinMaxLength();

        this.panelData.forEach((reelData, index) => {
            this.reels[index].setData(reelData);
            if (this.placedSpecialWildsPerReel) {
                this.reels[index].setWildPlacements(this.placedSpecialWildsPerReel[index]);
            }
        });

        this.scheduleOnce(() => {
            this.splitPlacer.place(this.splits, this.isSlamStop).then(() => {
                this.splitsPlaced = true;
                this._checkForDataAndStopReels();
            });
        }, 0.6);

    },

    setFreespins(flag) {
        if (flag) {
            this.gameMode = GameMode.FREE_SPIN;
        } else {
            this.gameMode = GameMode.MAIN;
        }
        this.wayController.hideWays();

    },

    playWinAnticipationEffect (winningList, reelThreshold) {
        if (reelThreshold === 0) {
            for (let i = 0; i < this.panelData.length; i++) {
                const reel = this.panelData[i];

                for (let j = 0; j < reel.length; j++) {
                    this.reels[i].getBlockController(j).idle();
                }
            }
        }

        if (reelThreshold < 2) {
            return;
        }

        if (this.placedSpecialWilds && this.placedSpecialWilds.length) {
            return;
        }

        for (let i = 0; i < winningList.length; i++ ) {
            const winning = winningList[i];

            if (!winning.prize || winning.winningType === 'Scatter') {
                continue;
            }

            for (let j = 0; j < winning.winData.length; j++) {
                const { reel, row } = winning.winData[j];
                const circle = this.splitPlacer.getItem(row, reel);

                if (circle) {
                    const spine = circle.getComponentInChildren(sp.Skeleton);
                    if (spine.animation === 'idle1') {
                        spine.setAnimation(0, 'match', false);
                        this.audioMap.playSfx('activeWayMultiplier');
                        spine.addAnimation(0, 'idle2', true);
                    }
                }

                if (reel <= reelThreshold) {
                    this.reels[reel].getBlockController(row).playAnticipationGlow();
                }
            }
        }
    },

    spin(isFast) {
        this.isSlamStop = isFast;
        this.splitPlacer.spin(isFast);
        this._changeState(State.START_SPIN);
        if (this.gameState) {
            if (this.gameState.includes('RETRIGGERING') || this.gameState.includes('FS_RETRIGGERING')) {
                this.wildElectricitySoundId = this.audioMap.playSfx('wildShieldElectricityLoop', -1);
                this.wildProgress.prepareForShot();
            }
        }
    },

    slamStop() {
        this.isSlamStop = true;
        switch (this.state) {
            case State.SHOW_ALL_WIN_ANIMATION:
                this.totalPrizeController.finishAnimation();
                break;
            case State.SHOW_FREESPINS_WIN:
                this.freespinsPrizeController.onClick();
                break;
            case State.STOPPING_IMMEDIATELY:
                break;
            case State.STOPPING_STEP_BY_STEP:
                // this._changeState(State.STOPPING_IMMEDIATELY);
                break;

        }
    },

    isFreeSpinMode() {
        return this.gameMode === GameMode.FREE_SPIN;
    },

    showFreespinsTotal(prize) {
        this.state = State.SHOW_FREESPINS_WIN;

        this.freespinsPrizeController.node.once('finishing', () => {
            this.node.emit('finishing');
        });
        this.freespinsPrizeController.showPrize(prize, this.betAmount).then(() => {
            this.setFreespins(false);
            this.node.emit('freespinsEnd');
        });
    },

    destroyPanel() {
        this.previousStateData = this.panelData;
        this.panelData = null;
        this.splitsPlaced = false;
        this.winnings = null;

        this.reels.forEach((reel) => {
            reel.node.destroy();
        });
    },

    // TODO make better function for FS without calling this.setInitialPanelData();
    setFreespinPanelInitData() {
        this.gameMode = GameMode.FREE_SPIN;
    },

    _startSpin() {
        const spinPromises = [];

        for (let i = 0; i < this.reels.length; i++) {
            spinPromises.push(this.reels[i].spinReel());
        }
        Promise.all(spinPromises).then(() => {
            this._changeState(State.SPIN);
        });
    },

    _changeState(newState) {
        if (this.state === newState) {
            cc.error(`Try to set the same state! ${newState}`);
            return;
        }

        this.state = newState;
        switch (newState) {
            case State.IDLE:
                this._handleIdleState();
                break;
            case State.START_SPIN:
                this.stopWinnings();
                this.panelData = null; // reseting data and waiting for new one
                this.splitsPlaced = false; // reseting data and waiting for new one
                this.winnings = null;
                const spinPromises = [];
                this.scheduleOnce(() => {
                    this.shipControl.motion();
                },.3);
                const delay =  this.specialWildsController.isActive() ? 0.5 : 0;
                if ( this.specialWildsController.isActive()) {
                    this.specialWildsController.clear();
                }
                this.scheduleOnce(() => {
                    for (let i = 0; i < this.reels.length; i++) {
                        spinPromises.push(this.reels[i].spinReel());
                    }
                    Promise.all(spinPromises).then(() => {
                        this._changeState(State.SPIN);
                    });
                }, delay);
                break;
            case State.SPIN:
                this.currentReelIndex = 0;
                this.totalScattersAmount = 0;
                this.spinAudioId = this.audioMap.playSfx('reelSpinLoop', -1);
                this._checkForDataAndStopReels();
                break;
            case State.STOPPING_STEP_BY_STEP:
                this._stopReel();
                break;
            case State.STOPPING_IMMEDIATELY:
                const stopPromises = [];
                this.shipControl.idle();
                for (let i = this.currentReelIndex; i < this.reels.length; i++) {
                    stopPromises.push(this.reels[i].stopReel());
                }
                Promise.all(stopPromises).then(() => {
                    this.audioMap.playSfx('reelStop');
                    this._changeState(State.STOPPED);
                });
                break;
            case State.STOPPED:
                this.currentReelIndex = 0;
                this.currentReelIndex = 0;
                this.isSlamStop = false;
                this.playWinAnticipationEffect(this.winnings.winningList, 4);
                this._changeState(State.PLACE_WILDS);
                this.audioManager.stopSfx(this.spinAudioId);
                break;
            case State.PLACE_WILDS:
                // this.scheduleOnce(() => this.playWinAnticipationEffect(this.winnings.winningList, 0), 0.1);
                if (this.placedSpecialWilds && this.placedSpecialWilds.length) {
                    this.playWildPlacement();
                } else {
                    this._changeState(State.COLLECT_WILDS);
                }
                break;
            case State.COLLECT_WILDS:
                // this.scheduleOnce(() => this.playWinAnticipationEffect(this.winnings.winningList, 0), 0.1);
                if (this.collectedSpecialWilds && this.collectedSpecialWilds.length) {
                    if ( this.specialWildsController.isActive()) {
                        this.specialWildsController.clear();
                    }
                    this.playCollectWilds();
                } else {
                    this._changeState(State.SHOW_ALL_WIN_ANIMATION);
                }
                break;
            case State.SHOW_ALL_WIN_ANIMATION:
                if (this.winnings && this.winnings.winningList.length > 0) {
                    this._showAllWinnings().then(() => {
                        this._changeState(State.CLEAN);
                    });
                } else {
                    this._changeState(State.CLEAN);
                }
                break;
            case State.CLEAN:
                this._dimCurrentWinning();
                this._changeState(State.IDLE);
                break;
        }
    },

    playWildPlacement () {
        // this.placedSpecialWilds
        const blocks = this.placedSpecialWilds.map(item => this.reels[item.reel].getBlockController(item.row));

        const pr = this.gameMode === GameMode.MAIN ? this.mainSpecialWildProgress : this.fsSpecialWildProgress;

        this.wildProgress.shot(blocks, pr);
        if (this.wildElectricitySoundId) {
            this.audioManager.stopSfx(this.wildElectricitySoundId);
            this.wildElectricitySoundId = null;
        }

        this.scheduleOnce(() => this._changeState(State.COLLECT_WILDS), 2.5);
    },

    playCollectWilds () {
        const { reel, row } = this.collectedSpecialWilds.pop();

        const block = this.reels[reel].getBlockController(row);
        this.wildProgress.match(block).then(() => {
            if (this.collectedSpecialWilds.length) {
                this.playCollectWilds();
            } else {
                this._changeState(State.SHOW_ALL_WIN_ANIMATION);
            }
        });
    },

    _handleIdleState() {
        this.isSlamStop = false;
        this.totalStoppedScatter = 0;
        this.winMaxLength = -1;
        this.node.emit(this.state);
    },
    /**
     * When all reels started to spin, check if the datas available, and stop reels
     */
    _checkForDataAndStopReels() {
        if (this.state === State.SPIN && this.panelData && this.splitsPlaced) {
            if (this.collectedSpecialWilds && this.collectedSpecialWilds.length) {
                this.specialWildsController.appear(this.collectedSpecialWilds, this.slamStop).then(() => this._stopReels());
            } else {
                this._stopReels();
            }
        }
    },

    _stopReels () {
        if (this.isSlamStop) {
            this._changeState(State.STOPPING_IMMEDIATELY);
        } else {
            this._changeState(State.STOPPING_STEP_BY_STEP);
        }
    },

    _calculateWinMaxLength() {
        this.winMaxLength = this.winnings.winningList.reduce((l, winning) => {
            const nL = winning.winData.reduce((s, coord) => Math.max(coord.reel, s), 0);
            return Math.max(l, nL)
        }, 0);
    },

    _stopReel() {
        if (this.currentReelIndex === this.reels.length) {
            this._changeState(State.STOPPED);
            return;
        }

        const { totalWinning, betAmount } = this.winnings;
        const winAnticipation = totalWinning / betAmount > 8
            && this.currentReelIndex > 2
            && this.currentReelIndex <= this.winMaxLength + 1
            && !(this.placedSpecialWilds && this.placedSpecialWilds.length);
        const scatterAnticipation = this.totalScattersAmount === 2;
        const hasSpecialWildData = (this.collectedSpecialWilds && this.collectedSpecialWilds.length);
        // eslint-disable-next-line max-len
        this.reels[this.currentReelIndex].stopReel(scatterAnticipation, winAnticipation, this.currentReelIndex, hasSpecialWildData).then(() => {
            if (this.currentReelIndex === this.reels.length - 2) {
                this.shipControl.idle();
            }
            if (this.state === State.STOPPING_IMMEDIATELY) {
                return;
            }

            if (this.currentReelIndex > 1) {
                this.playWinAnticipationEffect(this.winnings.winningList, this.currentReelIndex);
            }

            if (this.reels[this.currentReelIndex].hasScatter()) {
                this.audioMap.playSfx('scatter' + (this.currentReelIndex));
                this.totalScattersAmount++;

            }
            if (this.totalScattersAmount === 3) {
                this.cameraController.shake(5, .5, 8);
            }

            this.currentReelIndex++;
            this.audioMap.playSfx('reelStop');
            if (this.isSlamStop) {
                this.unscheduleAllCallbacks();
                this._changeState(State.STOPPING_IMMEDIATELY);
                return;
            }

            if (this.currentReelIndex === this.reels.length) {
                this._changeState(State.STOPPED);
            } else {
                this._stopReel();
            }
        });
    },

    showWinnings() {
        this.winningsCounter = 0;
        this.currentWinningIndex = 0;

        if (this.winnings && this.winnings.winningList.length > 1) {
            this._showNextWinning();
        }
    },

    stopWinnings() {
        this.winSymbolsContainer.stopAllActions();
        this.winlinePrizeController.hide();
        this._hideOverlay();
        this._dimCurrentWinning();
    },

    _showWinning(winning) {
        return new Promise((resolve) => {
            this.audioMap.playSfx('winMatch');
            this.currentWinningCluster.length = 0;
            this.currentWinningCircles.length = 0;
            // check if prize type is money and show the prize
            if (winning.winningType === 'Way') {
                this.winlinePrizeController.showPrize(winning.prize, this.winnings.betAmount);
            }
            // if winning index exists also draw a line
            if (!isNaN(winning.index)) {
                this.paylinesController.showPayline(winning.index);
            }
            this.audioMap.playWinMatchSfx(winning.mainSymbol);
            // this._playSymbolSfx(winning.mainSymbol);
            this._showOverlay();
            for (let i = 0; i < winning.winData.length; i++) {
                const { reel, row } = winning.winData[i];
                const blockContoller = this.reels[reel].getBlockController(row);
                const block = blockContoller.node;
                const position = block.parent.convertToWorldSpaceAR(block.position);

                blockContoller.match();
                block.position = this.winSymbolsContainer.convertToNodeSpaceAR(position);
                block.oldParent = block.parent;
                block.parent = null;
                this.winSymbolsContainer.addChild(block);
                this.currentWinningCluster.push(block);

                const circle = this.splitPlacer.getItem(row, reel);
                if (circle) {
                    circle.setParentKeepPosition(this.winSymbolsContainer);
                    this.currentWinningCircles.push(circle);
                }
            }
            this.winSymbolsContainer.runAction(cc.sequence(
                cc.delayTime(DURATION_BETWEEN_WIN_HIGHLIGHTS - 0.2),
                cc.callFunc(() => {
                    this.winlinePrizeController.hide();
                }),
                cc.delayTime(0.3),
                cc.callFunc(() => {
                    this._dimCurrentWinning();
                    resolve();
                })
            ));
        });
    },

    _dimCurrentWinning() {
        /* if (this.state === State.WIN) */ {
            for (let i = 0; i < this.currentWinningCluster.length; i++) {
                const block = this.currentWinningCluster[i];

                const position = block.parent.convertToWorldSpaceAR(block.position);

                block.position = block.oldParent.convertToNodeSpaceAR(position);
                block.parent = null;
                block.oldParent.addChild(block);
                block.getComponent(BlockPrefabController).idle();
            }
            for (let i = 0; i < this.currentWinningCircles.length; i++) {
                const circle = this.currentWinningCircles[i];
                circle.setParentKeepPosition(this.splitPlacer.node);
            }
            this.currentWinningCluster.length = 0;
            this.currentWinningCircles.length = 0;
            this.paylinesController.clearLines();
        }
    },

    _showNextWinning() {
        if (this.winningsCounter === this.winnings.winningList.length) {
            this._hideOverlay();
            return;
        }

        this.currentWinningIndex = ++this.currentWinningIndex % this.winnings.winningList.length;
        const winlineData = this.winnings.winningList[this.currentWinningIndex];

        // delay before showing the winlines
        this.scheduleOnce(() => {
            if (this.state === State.IDLE) {
                this._showWinning(winlineData).then(() => {
                    this.winningsCounter++;
                    this._showNextWinning();
                });
            }
        }, 0.2)
    },

    startFreespinAnimation() {
        this.setFreespins(true);
    },

    _showAllWinnings() {
        // this._dimCurrentWinning();
        return new Promise((resolve) => {
            this.audioMap.playSfx('winMatch');
            this._showOverlay();
            const winningBlocks = [];
            const winningCircles = [];

            if (this.winnings.winningList.length === 1) {
                // this._playSymbolSfx(this.winnings.winningList[0].mainSymbol);
                this.audioMap.playWinMatchSfx(this.winnings.winningList[0].mainSymbol);
            }
            this.winnings.winningList.forEach((winning) => {
                // we only want to show LINE winnings in FS because Scatter winnings happen only after symbol override.
                if (this.isFreeSpinMode() && winning.winningType === 'SCATTER' && winning.mainSymbol !== 'SC') {
                    return;
                }

                // if it is a scatter win with WI symbol in Freespins then we know we got extra freespins
                if (this.isFreeSpinMode() && winning.winningType === 'SCATTER' && winning.mainSymbol === 'SC' &&
                    winning.prizeType === 'FEATURE_START') {
                    this.node.emit('freeGamesUpdateRetriggered');
                }
                for (let i = 0; i < winning.winData.length; i++) {
                    const coord = winning.winData[i];
                    const blockController = this.reels[coord.reel].getBlockController(coord.row);
                    const block = blockController.node;
                    if (!isNaN(winning.index)) {
                        this.paylinesController.showPayline(winning.index);
                    }
                    if (winningBlocks.indexOf(block) < 0) {
                        winningBlocks.push(block);
                        const circle = this.splitPlacer.getItem(coord.row, coord.reel);

                        if (circle && winning.mainSymbol !== 'SC') {
                            winningCircles.push(circle);
                            const spine = circle.getComponentInChildren(sp.Skeleton);
                            if (spine.animation === 'idle1') {
                                spine.setAnimation(0, 'match', false);
                                this.audioMap.playSfx('activeWayMultiplier');
                                spine.addAnimation(0, 'idle2', true);
                            }
                        }
                    }
                }
            });
            winningBlocks.forEach((block) => {
                const position = block.parent.convertToWorldSpaceAR(block.position);

                block.getComponent(BlockPrefabController).match(this.isFreeSpinMode());
                block.position = this.winSymbolsContainer.convertToNodeSpaceAR(position);
                block.oldParent = block.parent;
                block.parent = null;
                this.winSymbolsContainer.addChild(block);
            });

            winningCircles.forEach((circle) => {
                circle.setParentKeepPosition(this.winSymbolsContainer);
            });

            this.scheduleOnce(() => {
                this.wayController.showWinWays(this.winnings.totalWays);

                const totalWinnings = this.winnings.totalWinning;

                this.totalPrizeController.showPrize(totalWinnings,
                    this.winnings.betAmount).then(() => {
                        this._hideOverlay();
                        winningBlocks.forEach((block) => {
                            const position = block.parent.convertToWorldSpaceAR(block.position);

                            block.position = block.oldParent.convertToNodeSpaceAR(position);
                            block.parent = null;
                            block.oldParent.addChild(block);
                            block.getComponent(BlockPrefabController).idle();
                        });
                        winningCircles.forEach((circle) => {
                            circle.setParentKeepPosition(this.splitPlacer.node);
                        });
                        resolve();
                        this.wayController.setTotal();

                        // this.paylinesController.clearLines();
                    });
                if (this.isSlamStop) {
                    this.slamStop();
                }
            }, this.isSlamStop ? 0.2 : 0.6);
        });
    },

    _showOverlay(fadeTo = 120) {
        if (this.overlay.opacity !== 120) {
            this.overlay.active = true;
            this.overlay.stopAllActions();
            this.overlay.runAction(cc.fadeTo(0.2, 200));
        }
    },

    _hideOverlay() {
        this.overlay.stopAllActions();
        this.overlay.runAction(cc.fadeTo(0.2, 0));
    },

    getData() {
        return {
            gameState: this.gameState,
            panelData: this.panelData,
            // newPanelData: this.newPanelData,
            winnings: this.winnings,
            // scatterWinnings: this.scatterWinnings,
            // symbolOverrides: this.symbolOverrides,
            // symbolMovement: this.symbolMovement,
            // symbolMarker: this.symbolMarker,
            betAmount: this.betAmount,
            taxonomy: this.taxonomy,
            precookedReels: this.precookedReels,

            splits: this.splits
        }
    },
});
